<template>
<svg viewBox="0 0 14 14" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-export-new`]" width="1em" height="1em" v-bind="$attrs"><path d="M12.3257 11.4102C12.6928 11.4103 12.9907 11.708 12.9907 12.0752C12.9906 12.4423 12.6928 12.7401 12.3257 12.7402H1.67432C1.30711 12.7402 1.00938 12.4424 1.00928 12.0752C1.00928 11.7079 1.30705 11.4102 1.67432 11.4102H12.3257ZM7.00049 0.992188C7.36861 0.992264 7.66748 1.29104 7.66748 1.65918V8.18457L10.1685 5.68359C10.4288 5.4235 10.8515 5.42431 11.1118 5.68457C11.3712 5.94483 11.3714 6.36588 11.1118 6.62598L8.22607 9.51172C8.10195 9.63584 7.98016 9.75872 7.86963 9.85254C7.75325 9.95125 7.60515 10.0575 7.4126 10.1201C7.14499 10.207 6.85598 10.207 6.58838 10.1201C6.39537 10.0574 6.2469 9.95045 6.13037 9.85156C6.0199 9.75776 5.89797 9.63576 5.77393 9.51172L2.88916 6.62695C2.62884 6.36665 2.62891 5.94394 2.88916 5.68359C3.14952 5.42327 3.57217 5.42326 3.83252 5.68359L6.3335 8.18457V1.65918C6.3335 1.291 6.63231 0.992201 7.00049 0.992188Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineExportNew',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
